import { Link } from 'react-router-dom';
import { CreditCard, Banknote, Building2, ShieldCheck, Clock, Smartphone } from 'lucide-react';

const PaymentMethods = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-4xl font-bold text-[#2d3c5d] mb-4">Medios de Pago</h1>
          <p className="text-gray-600">
            Aceptamos los siguientes medios de pago para tu comodidad. Todas las transacciones son 100% seguras.
          </p>
        </div>

        {/* Mercado Pago */}
        <section className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-8 mb-6 text-white">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center">
              <img
                src="https://http2.mlstatic.com/storage/logos-api-admin/aa2b8f70-5c85-11ec-ae75-df2bef173be2-m.svg"
                alt="Mercado Pago"
                className="h-12"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold">Mercado Pago</h2>
              <p className="text-blue-100">Pagá de forma rápida y segura</p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-4 mb-6">
            <div className="bg-white/10 rounded-lg p-4">
              <ShieldCheck className="w-8 h-8 mb-2" />
              <h3 className="font-bold mb-1">100% Seguro</h3>
              <p className="text-sm text-blue-100">Tus datos protegidos</p>
            </div>
            <div className="bg-white/10 rounded-lg p-4">
              <Clock className="w-8 h-8 mb-2" />
              <h3 className="font-bold mb-1">Acreditación inmediata</h3>
              <p className="text-sm text-blue-100">En la mayoría de los casos</p>
            </div>
            <div className="bg-white/10 rounded-lg p-4">
              <Smartphone className="w-8 h-8 mb-2" />
              <h3 className="font-bold mb-1">Pago fácil</h3>
              <p className="text-sm text-blue-100">Desde cualquier dispositivo</p>
            </div>
          </div>

          <p className="text-sm text-blue-100">
            Podés pagar con tarjeta de crédito, débito o saldo en tu cuenta de Mercado Pago.
          </p>
        </section>

        {/* Transferencia Bancaria */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <Building2 className="w-8 h-8 text-[#2d3c5d]" />
            <h2 className="text-2xl font-bold text-[#2d3c5d]">Transferencia Bancaria</h2>
          </div>
          <p className="text-gray-600 mb-4">
            Realizá una transferencia directa a nuestra cuenta bancaria.
          </p>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded mb-4">
            <p className="text-sm text-gray-700">
              <strong>Importante:</strong> Tenés 12 horas para realizar la transferencia y enviar el comprobante a{' '}
              <a href="mailto:info@decohomesinrival.com.ar" className="text-[#2d3c5d] hover:underline font-semibold">
                info@decohomesinrival.com.ar
              </a>
              {' '}indicando tu número de orden.
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-gray-700 text-sm">
              Una vez confirmado el pago, procesaremos tu pedido de inmediato.
            </p>
          </div>
        </section>

        {/* Efectivo */}
        <section className="bg-white rounded-lg shadow-lg p-8 mb-6">
          <div className="flex items-center gap-3 mb-6">
            <Banknote className="w-8 h-8 text-[#2d3c5d]" />
            <h2 className="text-2xl font-bold text-[#2d3c5d]">Efectivo</h2>
          </div>
          <p className="text-gray-600 mb-4">
            Podés abonar en efectivo al momento de retirar tu pedido en nuestro depósito.
          </p>
          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded">
            <p className="text-sm text-gray-700">
              <strong>Retiro en depósito:</strong> Coordinamos el retiro una vez confirmada tu compra.
              El pago se realiza al momento de recibir los productos.
            </p>
          </div>
        </section>

        {/* Información adicional */}
        <div className="bg-[#2d3c5d] rounded-lg p-8 text-white">
          <h3 className="text-2xl font-bold mb-4">Información importante</h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <ShieldCheck className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: '#eddacb' }} />
              <p>Todas las transacciones online están protegidas con tecnología SSL de encriptación</p>
            </li>
            <li className="flex items-start gap-3">
              <CreditCard className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: '#eddacb' }} />
              <p>Los pagos con Mercado Pago se acreditan de forma inmediata</p>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: '#eddacb' }} />
              <p>Las transferencias bancarias se verifican en un plazo de 24 a 48 hs hábiles</p>
            </li>
          </ul>
        </div>

        {/* Botón volver */}
        <div className="mt-8">
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-lg font-semibold text-white transition hover:opacity-90"
            style={{ backgroundColor: '#2d3c5d' }}
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
